import React from 'react'

const LoadingSewar = () => {
  return (
    <div className='flex justify-center'>
        <h1>... Loading</h1>
    </div>
  )
}

export default LoadingSewar